import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-027b97b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "owner-detail"
}
const _hoisted_2 = { class: "detail-content" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "手机号：", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "可通行日期：", -1))
const _hoisted_10 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_ctx.detail.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detail.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["tag", _ctx.detail.house_json[0].house_user_type == '2' ? 'tag2' : 'tag1'])
            }, _toDisplayString(_ctx.detail.house_json[0].house_user_type_name), 3)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.detail.mobile), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.detail.house_json[0].date_start) + " - " + _toDisplayString(_ctx.detail.house_json[0].date_end), 1)
          ])
        ]),
        (_ctx.$route.query.type == '1')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_van_button, {
                style: {"margin-top":"auto"},
                class: "btn",
                color: "#3d6eeb",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.VISITOR_OWNER_EDIT,
            query: {
              userId: _ctx.detail.id,
              start: _ctx.$route.query.start,
              end: _ctx.$route.query.end
            }
          })
        ))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑人员")
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                style: {"margin":"10px 0 80px"},
                class: "btn",
                color: "#FC5820",
                onClick: _ctx.handleRemove
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除人员")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}